import { render } from "./LocalSwitcher.vue?vue&type=template&id=2ab91774&scoped=true"
import script from "./LocalSwitcher.vue?vue&type=script&lang=js"
export * from "./LocalSwitcher.vue?vue&type=script&lang=js"

import "./LocalSwitcher.vue?vue&type=style&index=0&id=2ab91774&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab91774"]])

export default __exports__